import apiClient from './client';
import type { Supplier, PaginatedResponse, SingleResponse } from '@/types';

export interface SupplierListParams {
  page?:       number;
  limit?:      number;
  search?:     string;
  activeOnly?: boolean;
}

export const suppliersApi = {
  list: (params: SupplierListParams = {}) =>
    apiClient.get<PaginatedResponse<Supplier>>('/suppliers', { params }).then(r => r.data),

  listAll: () =>
    apiClient.get<SingleResponse<Pick<Supplier, 'id' | 'name'>[]>>('/suppliers/all').then(r => r.data.data),

  get: (id: string) =>
    apiClient.get<SingleResponse<Supplier>>(`/suppliers/${id}`).then(r => r.data.data),

  create: (data: Partial<Supplier>) =>
    apiClient.post<SingleResponse<Supplier>>('/suppliers', data).then(r => r.data.data),

  update: (id: string, data: Partial<Supplier>) =>
    apiClient.put<SingleResponse<Supplier>>(`/suppliers/${id}`, data).then(r => r.data.data),

  delete: (id: string) =>
    apiClient.delete(`/suppliers/${id}`).then(r => r.data),
};
